const wrapper = "_35swc1b04j";

export { wrapper };
import "./audio.style.linaria.module.css";
//# sourceMappingURL=audio.style.js.map
